module.exports = __webpack_public_path__ + "static/img/21.bacadcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/21.jpg
// module id = kS6/
// module chunks = 0